/**
 * Utility functions for the game
 * @module utils
 */

import { MathUtils } from './math.js';
import { GraphicsUtils } from './graphics.js';

export const Utils = {
    ...MathUtils,
    ...GraphicsUtils
};
